<template>
	<BaseCard :is-editable="isEditable" :title="$t('damage_assessor').toString()" :is-toggleable="false" @clickEdit="edit">
		<BaseCardRow :value="damageAssessorName" :label="$t('assigned_damage_assessor')" />

		<BaseCardRow v-if="damageAssessorPhone" :value="damageAssessorPhone" :label="$t('phone')" />

		<BaseCardRow v-if="damageAssessor?.email" :value="damageAssessor.email" :label="$t('e_mail')" />
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import { concatArray } from '@/plugins/Utils';

export default {
	name: 'DamageAssessorCaseDamageAssessorCard',

	components: {
		BaseCard,
		BaseCardRow,
	},

	props: {
		damageAssessor: {
			type: Object,
			default: null,
		},

		caseId: {
			type: [Number, String],
			required: true,
		},

		isEditable: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		damageAssessorName() {
			if (!this.damageAssessor) {
				return '-';
			}

			return (
				concatArray([
					this.damageAssessor.firstName ?? this.damageAssessor.first_name,
					this.damageAssessor.lastName ?? this.damageAssessor.last_name,
				]) || '-'
			);
		},

		damageAssessorPhone() {
			if (!this.damageAssessor) {
				return null;
			}

			return (
				this.damageAssessor.cellNumber ??
				this.damageAssessor.cell_number ??
				this.damageAssessor.phoneNumber ??
				this.damageAssessor.phone_number ??
				this.damageAssessor.phone ??
				null
			);
		},
	},

	methods: {
		edit() {
			this.$router.push({
				name: 'changeDamageAssessor',
				params: {
					id: this.caseId,
				},
			});
		},
	},
};
</script>
